export default "__VITE_ASSET__UeXHwaYE__"